import { useLocation, useNavigate } from "react-router-dom";
import { ActionTypes, useAppDispatch, useAppState } from "../../Store";
import { useEffect } from "react";

export default function useAuthenticated() {
    const appState = useAppState();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const currentSearch = location.search;
    const fullPath = currentSearch ? `${currentPath}${currentSearch}` : currentPath;
    const dispatch = useAppDispatch();
    const { isAuthenticated } = appState;

    useEffect(() => {
        if (!isAuthenticated) {
            console.log('isAuthenticated', fullPath);
            dispatch({ type: ActionTypes.SET_PATH_AFTER_LOGIN, payload: fullPath });
            navigate('/login');
        }
    }, [isAuthenticated]);

    return {
        isAuthenticated,
        pathAfterLogin: fullPath
    }
}